import { WebStorageStateStore } from "oidc-client-ts";
import {
  APP_KEYCLOAK_AUTH_AUTHORITY,
  APP_KEYCLOAK_CLIENT_ID,
} from "@Constants/tokens";

export const createOidcConfig = () => ({
  authority: APP_KEYCLOAK_AUTH_AUTHORITY(),
  client_id: APP_KEYCLOAK_CLIENT_ID(),
  redirect_uri: window.location.origin,
  post_logout_redirect_uri: window.location.origin,
  response_type: "code",
  scope: "openid profile email",
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
});
